import axios from "axios";

export const ROOT_URL: string = process.env.REACT_APP_INSIGHT24_API_URL!

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.baseURL = ROOT_URL;